import { ApisauceInstance } from 'apisauce'
import { ChatChannelInstance } from '../types'
import { alert } from '@codeleap/modals'

export class BaseChatClass {
  protected api: ApisauceInstance

  constructor(api: ApisauceInstance) {
    this.api = api
  }
}

export function isChatGroup(channel?: Pick<ChatChannelInstance, 'type'>): boolean {
  return channel?.type === 'team'
}

export function alertMembersLimitExceeded(selectedMembers: number) {
  alert.error({
    title: 'Member limit reached',
    body: `You can only select up to ${selectedMembers} members at a time.`,
  })
}